import { useEtherBalance } from "@usedapp/core"

import { bnNumberOrZero } from "utils/web3/bn-number-or-zero"

import { useWallet } from "./use-wallet"

export function useNativeBalance() {
  const { account } = useWallet()
  const etherBalance = useEtherBalance(account)

  return {
    balance: etherBalance ? bnNumberOrZero(etherBalance) : undefined,
    balanceBn: etherBalance,
  }
}
